import { render, staticRenderFns } from "./Venue.vue?vue&type=template&id=3ed6063c"
import script from "./Venue.vue?vue&type=script&lang=ts"
export * from "./Venue.vue?vue&type=script&lang=ts"
import style0 from "./Venue.vue?vue&type=style&index=0&id=3ed6063c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports